export const routePath = {
  default: {
    path: '/',
  },
  mbtiRegister: {
    path: '/mbti-register',
  },
  mbtiByUuid: {
    path: '/mbti/:uuid',
  },
  survey: {
    path: '/:id',
  },
  testPath: {
    path: '/jwparktestpath',
  },
  expiredPath: {
    path: '/expired',
  },
};
